(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

/* ===== STICKY HEADER ===== */
class StickyHeader extends HTMLElement {
  constructor() { super(); }
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }
  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }
  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(d => d.close());
  }
  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}
customElements.define('sticky-header', StickyHeader);

/* ===== CATEGORIES MEGA MENU ===== */
document.addEventListener('DOMContentLoaded', () => {

  /* Mobile drawer */
  const drawerDetails = document.querySelector('#Details-menu-drawer-container');
  if (drawerDetails) {
    drawerDetails.addEventListener('toggle', () => {
      document.body.classList.toggle('menu-open', drawerDetails.hasAttribute('open'));
    });
  }

  /* Categories mega menu */
  const nav       = document.getElementById('categoriesNav');
  const btn       = document.getElementById('categoriesBtn');
  const mega      = document.getElementById('categoriesMega');
  const listItems = document.querySelectorAll('#categoriesList li');
  const subPanels = document.querySelectorAll('.categories-mega__sub');

  if (!nav || !mega) return;

  let closeTimer = null;

  function openMega() {
    clearTimeout(closeTimer);
    nav.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
  }

  function closeMega() {
    closeTimer = setTimeout(() => {
      nav.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }, 120);
  }

  function showSub(index) {
    subPanels.forEach(p => p.classList.remove('is-visible'));
    listItems.forEach(li => li.classList.remove('is-active'));
    const target = document.querySelector(`.categories-mega__sub[data-cat-sub="${index}"]`);
    const item   = document.querySelector(`#categoriesList li[data-cat-index="${index}"]`);
    if (target) target.classList.add('is-visible');
    if (item)   item.classList.add('is-active');
  }

  /* Hover on category items */
  listItems.forEach(li => {
    const idx = li.dataset.catIndex;
    li.addEventListener('mouseenter', () => {
      if (li.querySelector('[data-has-sub]')) {
        showSub(idx);
      } else {
        subPanels.forEach(p => p.classList.remove('is-visible'));
        listItems.forEach(l => l.classList.remove('is-active'));
        li.classList.add('is-active');
      }
    });
  });

  /* Show first sub panel by default */
  if (subPanels.length > 0) {
    subPanels[0].classList.add('is-visible');
    if (listItems.length > 0) listItems[0].classList.add('is-active');
  }

  /* Open/close on hover */
  nav.addEventListener('mouseenter', openMega);
  nav.addEventListener('mouseleave', closeMega);
  mega.addEventListener('mouseenter', openMega);
  mega.addEventListener('mouseleave', closeMega);

  /* Toggle on click (touch devices) */
  btn.addEventListener('click', (e) => {
    const isOpen = nav.classList.contains('is-open');
    if (isOpen) {
      closeMega();
    } else {
      e.preventDefault();
      openMega();
    }
  });

  /* Close on outside click */
  document.addEventListener('click', (e) => {
    if (!nav.contains(e.target)) {
      nav.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }
  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-product-section"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    
    // ============================================
    // GERENCIAMENTO DE VARIANTES
    // ============================================
    const variantSelects = document.querySelectorAll('.pp-variant-select');
    
    variantSelects.forEach(select => {
      // Previne duplicação de eventos
      if (select.hasAttribute('data-pp-initialized')) return;
      select.setAttribute('data-pp-initialized', 'true');
      
      select.addEventListener('change', function() {
        const variantId = this.value;
        const variantInput = this.closest('.pp-product-details').querySelector('.pp-variant-input');
        
        if (variantInput) {
          variantInput.value = variantId;
        }
      });
    });

    // ============================================
    // ADD TO CART AJAX
    // ============================================
    const addToCartForms = document.querySelectorAll('.pp-add-to-cart-form');
    
    addToCartForms.forEach(function(form) {
      // Previne duplicação de eventos
      if (form.hasAttribute('data-pp-cart-initialized')) return;
      form.setAttribute('data-pp-cart-initialized', 'true');

      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const button = form.querySelector('.pp-buy-button');
        const variantId = form.querySelector('.pp-variant-input').value;
        const btnText = button.querySelector('.pp-btn-text');
        const btnLoading = button.querySelector('.pp-btn-loading');

        // Previne múltiplos cliques
        if (button.disabled) return;

        // Estado de loading
        button.disabled = true;
        button.classList.add('loading');

        // FormData para Shopify
        const fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', 1);

        fetch('/cart/add.js', {
          method: 'POST',
          body: fd
        })
        .then(response => {
          if (!response.ok) throw new Error('Erro ao adicionar');
          return response.json();
        })
        .then(data => {
          console.log('Produto adicionado:', data);
          
          // Remove loading
          button.disabled = false;
          button.classList.remove('loading');
          
          // Feedback visual
          btnText.textContent = 'Adicionado!';
          setTimeout(() => {
            btnText.textContent = 'Adicionar ao carrinho';
          }, 2000);

          // Atualiza e abre o carrinho
          updateAndOpenCart();
        })
        .catch(error => {
          console.error('Erro:', error);
          button.disabled = false;
          button.classList.remove('loading');
          
          btnText.textContent = 'Erro! Tente novamente';
          setTimeout(() => {
            btnText.textContent = 'Adicionar ao carrinho';
          }, 3000);
        });
      });
    });

    // ============================================
    // ATUALIZA E ABRE O CARRINHO
    // ============================================
    function updateAndOpenCart() {
      console.log("Atualizando carrinho...");

      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          console.log("Carrinho atual:", cart);
          
          const cartDrawer = document.querySelector('cart-drawer');
          
          if (cartDrawer) {
            fetch(window.location.href)
              .then(response => response.text())
              .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newCartDrawer = doc.querySelector('cart-drawer');
                
                if (newCartDrawer && cartDrawer) {
                  cartDrawer.outerHTML = newCartDrawer.outerHTML;
                  
                  setTimeout(() => {
                    const updatedDrawer = document.querySelector('cart-drawer');
                    if (updatedDrawer) {
                      openCartDrawer();
                    }
                  }, 100);
                }
              })
              .catch(err => {
                console.error("Erro ao recarregar drawer:", err);
                window.location.href = '/cart';
              });
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(err => {
          console.error("Erro ao buscar carrinho:", err);
          window.location.href = '/cart';
        });
    }

    function openCartDrawer() {
      console.log("Tentando abrir drawer...");
      
      const cartIcon = document.querySelector("#cart-icon-bubble");
      if (cartIcon) {
        console.log("Abrindo via cart-icon-bubble");
        cartIcon.click();
        return;
      }

      const drawerSummary = document.querySelector('cart-drawer summary');
      if (drawerSummary) {
        console.log("Abrindo via summary");
        drawerSummary.click();
        return;
      }

      const details = document.querySelector('cart-drawer details');
      if (details) {
        console.log("Abrindo via details");
        details.setAttribute('open', '');
        return;
      }

      const cartLink = document.querySelector('a[href*="/cart"]');
      if (cartLink) {
        console.log("Abrindo via link do carrinho");
        cartLink.click();
        return;
      }

      console.warn("Nenhum método funcionou, redirecionando...");
      window.location.href = '/cart';
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
